var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-style"},[_c('Button',{staticClass:"edit",attrs:{"icon":"md-add","type":_vm.type,"shape":"circle"},on:{"click":function($event){return _vm.handleClick()}}}),_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }